import React, { Fragment } from 'react';
import Panel from '../../../../components/outline/Panel';
import TableWithSummary from '../../../../components/table/TableWithSummary';
import Button from '../../../../components/Button';
import { EVENT_LIST_TABLE_EMPTY_TEXT } from '../../../../constants/service/app/eventConstants';
import columns from './columns';
import { EVENT_LIST_FILTER_OPTION_MODEL } from '../../../../store/modules/event/models';
import { LIST_PAGINATION_MODEL } from '../../../../store/modules/app/models';

const EventExposureList = (props) => {
  const {
    inProgressEventList,
    originalInProgressEventList,
    getList,
    getExcelDownload,
    openEventItemListModal,
    isUpdateList,
    setInitialInProgressEventList,
    getEventTagColumnTagList,
  } = props;
  const { list, filterOption, pagination, summary } = inProgressEventList;

  return (
    <div className="event-inProgress-list">
      <Panel>
        <div className="panel-header">
          <div className="title">진행중인 기획전 리스트</div>
          <div className="btn-area">
            {
              /**
               *  진행중인 기획전 리스트가 변경이 있을 때만 초기화, 저장 버튼을 노출한다
               */
              isUpdateList ? (
                <Fragment>
                  <Button isRadius text="초기화" onClick={() => setInitialInProgressEventList()} />
                </Fragment>
              ) : null
            }
          </div>
        </div>

        <div className="panel-body">
          <TableWithSummary
            data={list}
            totalCnt={summary.totalCnt}
            initialOption={{
              filterOption: EVENT_LIST_FILTER_OPTION_MODEL,
              pagination: LIST_PAGINATION_MODEL,
            }}
            emptyText={EVENT_LIST_TABLE_EMPTY_TEXT}
            showPagination
            filterOption={filterOption}
            pagination={pagination}
            getList={getList}
            getExcelDownload={getExcelDownload}
            getTdProps={(state, rowInfo) => {
              const currentStatus = rowInfo?.original?.status;
              const originalStatus = originalInProgressEventList?.[rowInfo?.index]?.status;

              return {
                className: currentStatus && originalStatus && currentStatus !== originalStatus ? 'isChange' : null,
              };
            }}
            columns={(utils) =>
              columns({
                openEventItemListModal,
                getEventTagColumnTagList,
                ...utils,
              })
            }
          />
        </div>
      </Panel>
    </div>
  );
};

export default EventExposureList;
